import { render, staticRenderFns } from "./GuestDocumentation.vue?vue&type=template&id=0a484167&"
import script from "./GuestDocumentation.vue?vue&type=script&lang=js&"
export * from "./GuestDocumentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports